export default __webpack_public_path__ + "static/media/our-services-edu-primary.c0f16a24.jpg";